import { cn } from "@/lib/utils";
import Image from "next/image";
import { AnimatedEffect } from "./AnimatedEffect";

export const CrateProgressBar = ({
  currentStep,
  handleProgressBarClick,
}: {
  currentStep: number;
  handleProgressBarClick: (segment: string) => void;
}) => {
  return (
    <div className="p-2 gap-x-0.5 flex items-center">
      {/* First Progress Bar - Bronze */}
      {/* biome-ignore lint/a11y/useKeyWithClickEvents: tracking only onclick */}
      <div
        className={cn(
          "min-w-0 flex-1 relative h-2 rounded-[0.125rem] glass-container-border before:rounded-[0.125rem] before:!inset-0 before:!opacity-100 after:!opacity-0 transition-all duration-500",
          currentStep >= 2
            ? "bg-gradient-to-r from-[#D37A38] to-[#F5A623]"
            : "bg-white/20",
          currentStep === 1 && "animate-pulse",
        )}
        onClick={() => handleProgressBarClick("Segment 1")}
      />
      {/* Bronze Crate */}
      <div className="relative max-w-11 w-[7.5vw]">
        {currentStep === 1 && (
          <div className="absolute inset-0 -m-2 animate-pulse">
            <AnimatedEffect className="absolute w-full h-full" tint="#D37A38" />
          </div>
        )}
        <Image
          src="/assets/steam-onboarding/crate-bronze.webp"
          alt=""
          width={44}
          height={44}
          className={cn(
            "max-w-11 w-[7.5vw] relative z-10 transition-transform duration-300",
            currentStep === 1 && "scale-110",
          )}
          onClick={() => handleProgressBarClick("Bronze Crate")}
        />
      </div>
      {/* Second Progress Bar - Silver */}
      {/* biome-ignore lint/a11y/useKeyWithClickEvents: tracking only onclick */}
      <div
        className={cn(
          "min-w-0 flex-1 relative h-2 rounded-[0.125rem] glass-container-border before:rounded-[0.125rem] before:!inset-0 before:!opacity-100 after:!opacity-0 transition-all duration-500",
          currentStep >= 4
            ? "bg-gradient-to-r from-[#D37A38] to-[#F5A623]"
            : "bg-white/20",
        )}
        onClick={() => handleProgressBarClick("Segment 2")}
      />
      {/* Silver Crate */}
      <div className="relative max-w-11 w-[7.5vw]">
        {currentStep === 4 && (
          <div className="absolute inset-0 -m-2 animate-pulse">
            <AnimatedEffect className="absolute w-full h-full" tint="#D37A38" />
          </div>
        )}
        <Image
          src="/assets/steam-onboarding/crate-silver.webp"
          alt=""
          width={44}
          height={44}
          className={cn(
            "max-w-11 w-[7.5vw] relative z-10 transition-transform duration-300",
            currentStep === 4 && "scale-110",
          )}
          onClick={() => handleProgressBarClick("Silver Crate")}
        />
      </div>
      {/* Third Progress Bar - Gold */}
      {/* biome-ignore lint/a11y/useKeyWithClickEvents: tracking only onclick */}
      <div
        className={cn(
          "min-w-0 flex-1 relative h-2 rounded-[0.125rem] glass-container-border before:rounded-[0.125rem] before:!inset-0 before:!opacity-100 after:!opacity-0 transition-all duration-500",
          currentStep >= 7
            ? "bg-gradient-to-r from-[#D37A38] to-[#F5A623]"
            : "bg-white/20",
          currentStep === 6 && "animate-pulse",
        )}
        onClick={() => handleProgressBarClick("Segment 3")}
      />
      {/* Gold Crate */}
      <div className="relative max-w-11 w-[7.5vw]">
        {currentStep === 6 && (
          <div className="absolute inset-0 -m-2 animate-pulse">
            <AnimatedEffect className="absolute w-full h-full" tint="#D37A38" />
          </div>
        )}
        <Image
          src="/assets/steam-onboarding/crate-gold.webp"
          alt=""
          width={44}
          height={44}
          className={cn(
            "max-w-11 w-[7.5vw] relative z-10 transition-transform duration-300",
            currentStep === 6 && "scale-110",
          )}
          onClick={() => handleProgressBarClick("Gold Crate")}
        />
      </div>
    </div>
  );
};
